import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="privacy-overlay" onClick={onClose}>
      <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-header">
          <h2>Privacy Policy</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="privacy-content">
          <div className="privacy-intro">
            <p>
              At Kalyan Travels, we maintain exceptional standards for protecting your personal information. Data collected from visitors to our website operates under this privacy framework alongside our User Terms of Service. We gather personal details when you register an account, browse our platform, or engage with our services. Your confidence in our data handling practices is fundamental to our relationship. We encourage you to thoroughly review this privacy statement.
            </p>
          </div>

          <section>
            <h3>Policy Updates</h3>
            <p>
              <strong>Notice:</strong> This privacy framework may be updated periodically without prior notification. We recommend checking this document regularly to stay informed of any modifications. Please note that this policy does not extend to our business associates, partner organizations, or external third-party services.
            </p>
          </section>

          <section>
            <h3>Data Collection Categories</h3>
            <p>We gather the following types of information from our users:</p>
            
            <div className="info-item">
              <h4><i className="fas fa-user"></i> Personal Information</h4>
              <p>Individual identification details including full name, email address, login credentials, telephone number, and mailing address for correspondence and service delivery</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-credit-card"></i> Financial Information</h4>
              <p>Payment-related data such as credit card numbers, cardholder names, expiry dates, and security codes or other financial instruments for online banking are securely processed through our certified payment gateway partners who maintain industry-leading security protocols for your financial protection.</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-shopping-cart"></i> Purchase Records</h4>
              <p>Historical booking information encompassing service details, pricing structure, purchase dates, transaction records, payment status, and related documentation.</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-chart-bar"></i> Research Participation</h4>
              <p>Voluntary feedback from online questionnaires conducted on our platform or affiliated sites, which may encompass demographic data (such as gender, age range, income level) along with service and product preferences.</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-cookie-bite"></i> Browser Data</h4>
              <p>Digital tracking files stored by our website in your browser that help remember user-specific information such as interface interactions, authentication status, and page viewing history. Major internet platforms including Amazon, Yahoo, Google, and Facebook utilize similar technology. Your browser settings allow you to control cookie acceptance and receive notifications when cookies are being placed.</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-chart-line"></i> Website Activity</h4>
              <p>Browsing behavior data including site navigation patterns, traffic sources, internet protocol addresses, browser specifications, language preferences, device operating systems, and timestamp information for each visit.</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-share-alt"></i> Social Media Integration</h4>
              <p>Authentication details from external platforms when you choose to connect through services like Facebook, Twitter, Google, Skype, or other social media accounts for streamlined access.</p>
            </div>

            <div className="info-item">
              <h4><i className="fas fa-envelope"></i> Correspondence Records</h4>
              <p>Direct communication between users and Kalyan Travels including inquiry messages, booking correspondence, transaction-related exchanges, dispute resolution communications, and customer service interactions.</p>
            </div>
          </section>

          <section>
            <h3>Information Security</h3>
            <p>
              We collect only the essential information required for business operations and delivering superior service to our clientele. This sensitive data is strictly confidential and will not be disclosed to unauthorized third parties.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;